module.exports = __webpack_public_path__ + "static/media/104-shopping bag.2988fcc8.svg";